import moment from "moment/moment";

export let PaperData = {
    institute_logo: '',
    school_name: '',
    template_name: '',
    exam_name: '',
    chapter_name: '',
    exam_time: '',
    exam_marks: '',
    board: '',
    medium: '',
    exam_date: moment(new Date()).format('DD/MM/YYYY'),
    paper_type: '',
    genrate_type: '',
    standard_id: '',
    standard_name: '',
    subject_id: '',
    subject_name: '',
    dualPaperView: 0,
    sections_info: [{
        section: "Section A",
        section_id: 1,
        divisions: [
            {
                division_id: 1,
                marks: 0,
                questionTitle: "",
                random_genrate_notice: "",
                question_data: [],
            }
        ]
    }],
    semester_id: '',
    semester_name: '',
}




